module.exports = __webpack_public_path__ + "static/media/sleep2.fee4dc92.jpg";